import { useEffect, useMemo, useState } from 'react'

import { useEVMWallet } from '@src/hooks/evm/useEVMWallet'
import { useSolanaWallet } from '@src/hooks/solana/useSolanaWallet'
import { useTronWallet } from '@src/hooks/tron/useTronWallet'
import { WalletConnectionsType } from '@src/types/walletConnection'

export const useWalletConnections = () => {
    const [isAnyWalletConnected, setIsAnyWalletConnected] = useState<boolean>(false)

    const { isEVMConnected, EVMChainId, evmWalletAddress } = useEVMWallet()
    const { isSolanaConnected, solanaWalletAddress } = useSolanaWallet()
    const { isTronConnected, tronWalletAddress } = useTronWallet()

    useEffect(() => {
        setIsAnyWalletConnected(isTronConnected || isSolanaConnected || isEVMConnected)
    }, [isTronConnected, isSolanaConnected, isEVMConnected])

    return useMemo(
        () =>
            ({
                isTronConnected,
                tronWalletAddress,
                isSolanaConnected,
                solanaWalletAddress,
                isEVMConnected,
                EVMChainId,
                evmWalletAddress,
                isAnyWalletConnected,
            }) as WalletConnectionsType,
        [
            isTronConnected,
            tronWalletAddress,
            isSolanaConnected,
            solanaWalletAddress,
            isEVMConnected,
            EVMChainId,
            evmWalletAddress,
            isAnyWalletConnected,
        ]
    )
}
